export const documentData = [
	{
		id: "remark",
		label: "Remark",
		placeholder: "",
		type: "textarea",
		helperText: "Any remark or additional information",
		validationType: "string",
		value: "",
		validations: [],
	},
	{
		id: "photo",
		label: "Photo *",
		placeholder:
			"Please upload a proper front-facing and clearly visible passport-size photo. Do not upload stylish or full-body photos.",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["photo is required"],
			},
		],
	},
	{
		id: "residenceProof",
		label: "Residence Proof",
		placeholder: "Residence Proof need to be provided as proof",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		// validations: [
		// 	{
		// 		type: "required",
		// 		params: ["Residence Proof is required"],
		// 	},
		// ],
		// action: [{ type: "required" }],
		rules: {
			or: [
				{
					"==": [{ var: "remark" }, "hidden"],
				},
			],
		},
	},
	{
		id: "aadharCardProof",
		label: "Aadhar Card *",
		placeholder: "Aadhar Card need to be provided as proof",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Aadhar Card is required"],
			},
		],
	},
	{
		id: "markSheetCopyProof",
		label: "MarkSheet Copy *",
		placeholder: "Graduation Degree Certificate / Marksheet Copy",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		// validations: [
		// 	{
		// 		type: "required",
		// 		params: ["MarkSheet Copy is required"],
		// 	},
		// ],
		rules: {
			or: [
				{
					"==": [{ var: "remark" }, "hidden"],
				},
			],
		},
	},
	{
		id: "graduationCertificateProof",
		label: "Degree Certificate *",
		placeholder: "Graduation Degree Certificate / Marksheet Copy",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Degree Certificate is required"],
			},
		],
	},
	{
		id: "postGraduationCertificateProof",
		label: "Post Graduation Degree Certificate *",
		placeholder: "Post Graduation Degree Certificate / Marksheet Copy",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Post Graduation Degree Certificate is required"],
			},
		],
	},
	{
		id: "signatoryProof",
		label: "Photo of Applicant's Signature *",
		placeholder: "Photo of Applicant's Signature",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
		validations: [
			{
				type: "required",
				params: ["Photo of Applicant's Signature is required"],
			},
		],
	},
	{
		id: "additionalDocs1",
		label: "Additional Document 1",
		placeholder:
			"Any document that does not exist above and is an additional ask by SVGA",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
	},
	{
		id: "additionalDocs2",
		label: "Additional Document 2",
		placeholder:
			"Any document that does not exist above and is an additional ask by SVGA",
		type: "upload",
		validationType: "string",
		value: "",
		elementWidth: 6,
	},
];
